module.exports = __webpack_public_path__ + "static/img/liveing(15).6cb390b8.png";